let chunkLoaded = false;

export async function preloadSearchChunk() {
    if (chunkLoaded) return;
    chunkLoaded = true;

    try {
        console.log("📦 Preloading Search.vue chunk...");
        await import("@/pages/foundation/Search.vue");
        console.log("✅ Search.vue chunk preloaded.");
    } catch (e) {
        console.warn("❌ Failed to preload Search.vue chunk:", e);
    }
}